export default __webpack_public_path__ + "static/media/lifongpay.f6c223b9.png";